import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "partzync_merchant_pos_simple_mode";
export const MERCHANT_POS_SIMPLE_MODE_EVENT = "partzync:merchant-pos-simple-mode";

/** ເມນູທີ່ cashier ໃຊ້ໃນໂໝດງ່າຍ */
export const CASHIER_SIMPLE_MODE_NAV_URLS = new Set([
  "/app/shops/$shopId",
  "/app/shops/$shopId/pos",
  "/app/shops/$shopId/pos/sales",
  "/app/shops/$shopId/catalog",
]);

export function isNavUrlAllowedInCashierSimpleMode(url: string): boolean {
  return CASHIER_SIMPLE_MODE_NAV_URLS.has(url);
}

export function getMerchantPosSimpleMode(): boolean {
  if (typeof sessionStorage === "undefined") return true;
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (raw === "0" || raw === "false") return false;
    if (raw === "1" || raw === "true") return true;
    return true;
  } catch {
    return true;
  }
}

export function setMerchantPosSimpleMode(enabled: boolean): void {
  if (typeof sessionStorage === "undefined") return;
  try {
    sessionStorage.setItem(STORAGE_KEY, enabled ? "1" : "0");
    window.dispatchEvent(new CustomEvent(MERCHANT_POS_SIMPLE_MODE_EVENT));
  } catch {
    /* ignore */
  }
}

export function useMerchantPosSimpleMode() {
  const [simpleMode, setSimpleModeState] = useState(() =>
    getMerchantPosSimpleMode(),
  );

  useEffect(() => {
    const sync = () => setSimpleModeState(getMerchantPosSimpleMode());
    window.addEventListener(MERCHANT_POS_SIMPLE_MODE_EVENT, sync);
    return () =>
      window.removeEventListener(MERCHANT_POS_SIMPLE_MODE_EVENT, sync);
  }, []);

  const setSimpleMode = useCallback((enabled: boolean) => {
    setMerchantPosSimpleMode(enabled);
    setSimpleModeState(enabled);
  }, []);

  const toggleSimpleMode = useCallback(() => {
    setSimpleMode(!getMerchantPosSimpleMode());
  }, [setSimpleMode]);

  return { simpleMode, setSimpleMode, toggleSimpleMode };
}
